import React, { useCallback } from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { DataSetEditSqlServerIntegrationHook } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetEditSqlServerIntegration';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { useCrudOperations } from 'apps/sigma2-ui/src/data-wizard/components/composite-dataset/recipes/use-crud-operations';
import { SqlServerIntegrationTable } from 'libs/end-to-end/src/types/databases/integrations/sql-server-integration';

export const DataSetSqlServerConfigurationTableListComponent = ({
  sqlServerIntegrationHook,
}: {
  sqlServerIntegrationHook: DataSetEditSqlServerIntegrationHook;
}) => {
  const language = useLanguage();

  const setTables = useCallback(
    (tables: SqlServerIntegrationTable[]) => {
      sqlServerIntegrationHook.setSqlServerIntegration({
        ...sqlServerIntegrationHook.sqlServerIntegration,
        tables,
      });
    },
    [sqlServerIntegrationHook],
  );

  const crudOps = useCrudOperations({
    items: sqlServerIntegrationHook.sqlServerIntegration.tables,
    setItems: setTables,
  });

  return (
    <>
      <S2Typography
        variant={'headline-3'}
        translatedContent={language.tableList()}
      />
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            crudOps.onAdd({
              tableName: '',
              schemaName: '',
            });
          },
        }}
        text={'Add Table'}
      />
      <Table
        items={sqlServerIntegrationHook.sqlServerIntegration.tables}
        columnDefinitions={[
          {
            id: 'tableName',
            header: () => <div>Table Name</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'tableName'}
                value={item.tableName}
                aria-label={'table name'}
                onChange={(event) => {
                  crudOps.onEdit(rowIndex, {
                    tableName: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'schemaName',
            header: () => <div>Schema Name</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'schemaName'}
                value={item.schemaName ?? ''}
                aria-label={'schema name'}
                onChange={(event) => {
                  crudOps.onEdit(rowIndex, {
                    schemaName: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'database',
            header: () => <div>Database</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'database'}
                value={item.database ?? ''}
                aria-label={'database'}
                onChange={(event) => {
                  crudOps.onEdit(rowIndex, {
                    database: event.target.value || undefined,
                  });
                }}
              />
            ),
          },
          {
            id: 'actions',
            header: () => <div>Actions</div>,
            cell: ({ rowIndex }) => (
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    crudOps.onDelete(rowIndex);
                  },
                }}
                text={'Remove'}
              />
            ),
          },
        ]}
      />
    </>
  );
};
